import { FormControlLabel, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import CustomSwitch from "../CustomSwitch";

const SwitchFilter = ({
  filterName,
  label,
  appliedFilters,
  setAppliedFilters,
}) => {
  const colors = useColors();

  return (
    <FormControlLabel
      sx={{
        background: colors.common_white,
        color: colors.contrast_text_dark,
        height: "32px",
        border: "1px solid " + colors.grey_32percent,
        textTransform: "unset",
        borderRadius: "8px",
        margin: "0",
        gap: 1,
        padding: "8px",
      }}
      control={
        <CustomSwitch
          checked={appliedFilters[filterName]}
          onChange={() => {
            setAppliedFilters({
              ...appliedFilters,
              [filterName]: !appliedFilters[filterName],
            });
          }}
        />
      }
      label={
        <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
          {label}
        </Typography>
      }
      labelPlacement="start"
    />
  );
};

export default SwitchFilter;
